import { Component, OnInit, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from "@angular/forms";
import { AuthenticationService } from 'src/app/shared/auth.service';
import { HospitalService } from 'src/app/shared/hospital.service';
import { environment } from "../../../environments/environment";
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { firstValueFrom } from 'rxjs';
import { NotificationService } from 'src/app/shared/notification.service';
import { findLandingOption, LandingOption } from 'src/app/shared/landing-routes.config';
declare var $ : any;

const authConfig: AuthConfig = {
  issuer: 'https://accounts.google.com',
  redirectUri: window.location.origin,
  clientId: '477541068341-c177g9m1tc47ptdgohkss225kver5t47.apps.googleusercontent.com',
  scope: 'openid profile email',
  strictDiscoveryDocumentValidation: false,
  // oidc: true,
  // responseType: 'code',
  showDebugInformation: true,
};

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public state = "login";
  guId: string;
  login: any;
  forgotPassword: any;
  recoveryPassword: any;
  isLoading = false;
  isError = false;
  message = "";

  isResetError: boolean;
  isChangePwdError: boolean;
  resetMessage = "";

  success_sent: boolean = false;

  login_spinner: boolean = false;

  token_check: any = null;
  alliance_check: any = null;
  his_ui: string;
  isOtpError: boolean = false;
  resendDisabled = false;
  resendTimer: number = 0;
  timerInterval: any;
  showMaxRetriesError: any = null;

  constructor(private router: Router, private authService: AuthenticationService, private hospitalService: HospitalService, private oauthService: OAuthService, private notificationService: NotificationService, private route: ActivatedRoute) {
    this.login = {
      email: "",
      password: ""
    };
    this.forgotPassword = {
      email: ""
    };
    this.recoveryPassword = {
      guid: "",
      password: ""
    };

    this.his_ui = environment.his_ui;
    this.oauthService.configure(authConfig);
    this.oauthService.loadDiscoveryDocumentAndTryLogin().then(async () => {
      // Now safe to get tokens
      const idToken = this.oauthService.getIdToken();
      if (this.authService.isTokenExpired() && idToken) {
        await this.loginUsingGoogle(idToken); 
      }
    });

  }

  async loginUsingGoogle(googleIdToken) {

    this.isLoading = true;
    this.isError = false;
    this.message = "";
    this.showMaxRetriesError = null;
    // console.log(userForm);
    try {
      this.login_spinner = true;
      // this.spinner.show();
      let response: any = await firstValueFrom(this.authService.googleLogin({ googleToken: googleIdToken }));

      if (response && response.data && response.data.two_factor_auth) {
        $('#login-form').modal('show');
        this.state = "otp-verification";
        this.login.email = response.data.email;
        this.login_spinner = false;
        this.login.hospital_id = response.data.hospital_id;
        return;
      }
      // console.log(response);
      let token = response["data"]["token"];
      this.activateUserSession(token);
    } catch (E) {
      this.isError = true;

      alert(JSON.stringify(E));

      this.message = "An error has occured.";
      if (E["error"] && E["error"]["data"] && E["error"]["data"]["message"]) {
        this.message = E["error"]["data"]["message"];
      }
      this.login_spinner = false;
      if (this.message && this.message.trim() !== "") {
        alert(this.message);
      }
    } finally {
      this.isLoading = false;
      // this.spinner.hide();
      this.login_spinner = false;
    }
  }

  loginGoogle() {
    this.oauthService.initLoginFlow();
  }

  logout() {
    this.oauthService.logOut();
  }

  get identityClaims() {
    return this.oauthService.getIdentityClaims();
  }

  get accessToken() {
    return this.oauthService.getAccessToken();
  }

  ngOnInit() {
  }

  forgetPassword() {
    this.state = "forget-password";
  }

  allianceData: any = null
  getAlliance() {
    try {
      this.allianceData = this.hospitalService.getRelatedEntities().subscribe(result => {
        if (result) {
          console.log(result);
          if (result) {
            localStorage.setItem("alliance", JSON.stringify(result["data"]));
          }
        }
      })
    } catch (E) {
      console.log(E);
    }
  }

  ngAfterViewInit() {
    // console.log("Here");
  }

  async recoverPassword(recoverPassForm) {
    // this.recoveryPassword = recoverPassForm;
    // this.isLoading = false;
    // this.isError = false;
    this.isChangePwdError = false;
    this.recoveryPassword.guid = this.guId;
    try {
      // this.spinner.show();
      let response = await this.authService
        .recoverPassword(this.recoveryPassword)
        .toPromise();
      // let message = response['data']['message'];
      // this.message = message;
      this.router.navigate([""]);
    } catch (E) {
      this.isChangePwdError = true;
    } finally {
      // this.spinner.hide();
    }
  }
  backToForgetPasswordPage() {
    this.state = "forget-password";
  }

  backToLoginPage() {
    this.state = "login";
  }

  async passwordChange(forgetPassForm: NgForm) {
    this.forgotPassword = forgetPassForm.value;
    // this.isLoading = true;
    this.login_spinner = true;
    // this.spinner.show();
    this.isResetError = false;
    // console.log(forgetPassForm);
    try {
      let response = await this.authService
        .changePassword(this.forgotPassword)
        .toPromise();
      this.resetMessage = "password reset link has been sent to your inbox.";
      forgetPassForm.reset();
    } catch (E) {
      console.log(E);
      this.isResetError = true;

      this.resetMessage = "email not registered";
      // this.message = "An error has occured";
      // if (E['error'] && E['error']['data'] && E['error']['data']['message']) {
      // this.message = E['error']['data']['message'];
      // }
    } finally {
      // this.isLoading = false;
      this.login_spinner = false;
      // this.spinner.hide();
    }
  }

  async doLogin(userForm) {
    this.login = userForm;
    this.isLoading = true;
    this.isError = false;
    this.message = "";
    this.showMaxRetriesError = null;
    // console.log(userForm);
    try {
      this.login_spinner = true;
      // this.spinner.show();
      let response: any = await this.authService.login(this.login).toPromise();

      if (response && response.data && response.data.two_factor_auth) {
        this.state = "otp-verification";
        this.login.email = response.data.email;
        this.login_spinner = false;
        this.login.hospital_id = response.data.hospital_id;
        return;
      }

      // console.log(response);
      let token = response["data"]["token"];
      this.activateUserSession(token);

    } catch (E) {
      this.isError = true;
      this.message = "An error has occured.";
      if (E["error"] && E["error"]["data"] && E["error"]["data"]["message"]) {
        this.message = E["error"]["data"]["message"];
      }
      this.login_spinner = false;
      this.showMaxRetriesError = E && E.error && E.error.data && E.error.data.error.rate_limited ? E.error.data.error.error : null;

    } finally {
      this.isLoading = false;
      // this.spinner.hide();
      this.login_spinner = false;
    }
  }

  async verifyOtp(otpForm) {

    otpForm['email'] = this.login.email;
    this.isLoading = true;

    try {
      const response: any = await this.authService.verifyOtp(otpForm).toPromise();

      if (response && response.data && response.data.token) {
        let token = response["data"]["token"];
        this.authService.setToken(token);

        this.activateUserSession(token);
      }
    } catch (E) {
      this.isOtpError = true;
      this.login_spinner = false;
    } finally {
      this.isLoading = false;
    }

  }

  async resendOtp() {
    this.showMaxRetriesError = null;
    try {
      this.resendDisabled = true;
      const notificationResponse = await this.notificationService.generateOtp({ email: this.login.email, hospital_id: this.login.hospital_id }).toPromise()

      this.resendTimer = 30;

      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }

      this.timerInterval = setInterval(() => {
        this.resendTimer--;
        if (this.resendTimer <= 0) {
          this.resendDisabled = false;
          clearInterval(this.timerInterval);
        }
      }, 1000);
    } catch (error) {
      this.showMaxRetriesError = error && error.error && error.error.data && error.error.data.rate_limited ? error.error.data.error : "Failed to resend OTP. Please try again later.";
      this.resendDisabled = true;  
    }
  }

  async getLandingPage(): Promise<LandingOption> {
    try {
      let response: any = await this.authService.getLandingPage().toPromise();
      let key = response && response["data"] ? response["data"]["landing_page"] : null;
      if(!key){
        return null;
      }
      return findLandingOption(key);
    } catch (E) {
      console.log(E);
      return null;
    }
  }

  async activateUserSession(token) {
    this.authService.setToken(token);
    let decodedData = this.authService.getDecodedToken();

    let alliance_response;
    try {
      alliance_response = await this.hospitalService.getRelatedEntities().toPromise();

      if (alliance_response) {
        localStorage.setItem(
          "alliance",
          JSON.stringify(alliance_response["data"])
        );
      }
    } catch (E) {
      console.log(E);
    }

    let user_switch_response;
    try {
      user_switch_response = await this.authService.getUserRelations().toPromise();
      if (user_switch_response) {
        localStorage.setItem(
          "user_alliance",
          JSON.stringify(user_switch_response["data"])
        );
      }
    } catch (E) {
      console.log(E);
    }

    if (alliance_response["data"]["organization"]["type"] == 1) {
      let landingOption = await this.getLandingPage();
      if (landingOption && landingOption.path) {
        document.location.href = landingOption.path;
      } else if (decodedData && decodedData.to_prescription) {
        document.location.href = 'prescription';
      } else {
        document.location.href = this.his_ui ? this.his_ui : '/his';
      }
    } else if (alliance_response["data"]["organization"]["type"] == 2) {
      document.location.href = 'pharmacy/product';
    } else if (alliance_response["data"]["organization"]["type"] == 3) {
      document.location.href = 'radiology/dashboard';
    } else if (alliance_response["data"]["organization"]["type"] == 4) {
      document.location.href = 'laboratory';
    } else if (alliance_response["data"]["organization"]["type"] == 5) {
      document.location.href = 'app/tpa/mail-client';
    } else if (alliance_response["data"]["organization"]["type"] == 7) {
      document.location.href = this.his_ui ? this.his_ui : '/his';
    } else if (alliance_response["data"]["organization"]["type"] == 8) {
      document.location.href = 'pharmacy/product';
    }

    localStorage.setItem("payment_popup", "false");
  }

} 
